import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import { getUserDisplayName, hasPagePermission } from '../authStorage';
import { useT } from '../i18n/translations';
import './Sidebar.css';
import logo from '../assets/logo.png';

const NAV_GROUPS = [
  {
    sectionKey: 'nav.home',
    items: [
      { to: '/app/dashboard',          labelKey: 'common.dashboard',     icon: 'dashboard',  moduleId: 'dashboard'         },
      { to: '/app/board',              labelKey: 'nav.board',            icon: 'board',      moduleId: 'board'             },
      { to: '/app/unified-matrix',     labelKey: 'nav.unifiedMatrix',    icon: 'report',     moduleId: 'unified_matrix'    },
    ],
  },
  {
    sectionKey: 'nav.management',
    items: [
      { to: '/app/secretaries',        labelKey: 'nav.secretary',        icon: 'user',       moduleId: 'users'             },
      { to: '/app/shareholders',       labelKey: 'nav.shareholders',     icon: 'money',      moduleId: 'shareholders'      },
      { to: '/app/departments',        labelKey: 'nav.departments',      icon: 'board',      moduleId: 'departments'       },
      { to: '/app/operational-plans',  labelKey: 'nav.plans',            icon: 'report',     moduleId: 'operational_plans' },
      { to: '/app/committees',         labelKey: 'nav.committees',       icon: 'board',      moduleId: 'committees'        },
    ],
  },
  {
    sectionKey: 'common.decisions',
    items: [
      { to: '/app/tasks',              labelKey: 'nav.taskManagement',   icon: 'settings'                                  },
      { to: '/app/meetings',           labelKey: 'common.meetings',      icon: 'calendar'                                  },
      { to: '/app/decision-types',     labelKey: 'nav.decisionTypes',    icon: 'decisions',  moduleId: 'decision_types'    },
      { to: '/app/decisions',          labelKey: 'common.decisions',     icon: 'decisions',  moduleId: 'decisions'         },
      { to: '/app/branches',           labelKey: 'nav.branches',         icon: 'branch',     moduleId: 'branches'          },
    ],
  },
  {
    sectionKey: 'nav.system',
    items: [
      { to: '/app/archive',            labelKey: 'nav.archive',          icon: 'report'                                    },
      { to: '/app/permissions',        labelKey: 'nav.userPermissions',  icon: 'lock',       moduleId: 'permissions'       },
      { to: '/app/settings',           labelKey: 'common.settings',      icon: 'settings'                                  },
    ],
  },
];

function Sidebar({ active, isOpen, onClose }) {
  const t = useT();
  const [collapsed, setCollapsed] = useState(false);
  const displayName = getUserDisplayName() || t('common.user');

  return (
    <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}${isOpen ? ' sidebar--mobile-open' : ''}`}>

      {/* Brand */}
      <div className="sidebar__brand">
        <img src={logo} alt={t('common.brand')} className="sidebar__brand-logo" />
        <div className="sidebar__brand-text">
          <div className="sidebar__brand-name">{t('common.brand')}</div>
          <div className="sidebar__brand-tagline">{t('common.brandTagline')}</div>
        </div>
        <button className="sidebar__mobile-close" onClick={onClose} aria-label={t('common.closeMenu')}>
          <Icon name="x-circle" size={18} color="rgba(255,255,255,0.7)" />
        </button>
      </div>

      {/* User pill */}
      <div className="sidebar__user">
        <div className="sidebar__user-avatar">أس</div>
        <div className="sidebar__user-info">
          <div className="sidebar__user-name">{displayName}</div>
          <div className="sidebar__user-role">{t('nav.systemUser')}</div>
        </div>
        <span className="sidebar__user-dot" />
      </div>

      {/* Nav */}
      <nav className="sidebar__nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.sectionKey}>
            <div className="sidebar__section-title">{t(group.sectionKey)}</div>
            {group.items.filter((item) => !item.moduleId || hasPagePermission(item.moduleId)).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `sidebar__item${isActive ? ' sidebar__item--active' : ''}`}
                data-label={t(item.labelKey)}
              >
                <span className="sidebar__item-icon">
                  <Icon name={item.icon} size={18} color="rgba(255,255,255,0.85)" />
                </span>
                <span className="sidebar__item-label">{t(item.labelKey)}</span>
                {item.badge && <span className="sidebar__badge">{item.badge}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Collapse toggle */}
      <button className="sidebar__toggle" onClick={() => setCollapsed(!collapsed)}>
        <span className="sidebar__toggle-icon">
          <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} size={15} color="rgba(255,255,255,0.5)" />
        </span>
        <span className="sidebar__toggle-label">{t('common.collapseMenu')}</span>
      </button>

    </aside>
  );
}

export default Sidebar;
